import { FILTER_PREFIXES } from 'src/global-files/resources/global-files.constants';
import { CONVERTIBLE_EXTENSIONS } from './common.constants';

export function isContactFile(file) {
  return file.id_path.replace(/\//g, '').startsWith(FILTER_PREFIXES.CONTACTS);
}

export function isMyFilesFile(file) {
  return file.id_path.replace(/\//g, '').startsWith(FILTER_PREFIXES.MY_FILES);
}

export function isInternalFile(file) {
  return file.id_path.replace(/\//g, '').startsWith(FILTER_PREFIXES.INTERNAL);
}

export function noExt(filename) {
  const extensionIndex = filename.lastIndexOf('.');
  return filename.slice(0, extensionIndex);
}

export function getExt(filename) {
  const extensionIndex = filename.lastIndexOf('.') + 1;
  return filename.slice(extensionIndex);
}

export function truncateFilename(name) {
  const ext = getExt(name);
  // The rename input is limited to 64, we will truncate to 58 to allow duplicate filename tickers up to (999)
  return noExt(name).substring(0, 58) + (ext ? '.' + ext : '');
}

export function getPreviewExtension(previewLink) {
  const fileUrl = previewLink.split('?')[0];
  const extensionIndex = fileUrl.lastIndexOf('.') + 1;
  return fileUrl.slice(extensionIndex);
}

export function isFileConvertible(file) {
  const ext = getExt(file.name || '');
  return !!CONVERTIBLE_EXTENSIONS[ext];
}
